import React from 'react';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';
const DeviationThumbOverlayTier = ({ width, height, children, className })=>{
    return /*#__PURE__*/ React.createElement(ThumbOverlayDefault, {
        width: width,
        height: height,
        isFaved: false,
        isCommented: false,
        statusIndicators: undefined,
        isMultiImage: false,
        mediaIndicator: undefined,
        className: className
    }, children);
};
DeviationThumbOverlayTier.displayName = 'DeviationThumbOverlayTier';
export default DeviationThumbOverlayTier;

//# sourceMappingURL=DeviationThumbOverlayTier.js.map